import { render, staticRenderFns } from "./FeatureRequestPrompt.vue?vue&type=template&id=45585828"
import script from "./FeatureRequestPrompt.vue?vue&type=script&lang=js"
export * from "./FeatureRequestPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports